var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$store.getters['isLogin'])?_c('HeaderisLogin'):_c('HeaderResponsive')}
var staticRenderFns = []

export { render, staticRenderFns }